<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label>Mã lớp <span class="text-danger">*</span></label>
            <ValidationProvider name="Mã lớp" rules="required| max:19" v-slot="{ errors,classes }" vid="34343434">
              <el-input v-model="form.classCode" placeholder="Nhập mã lớp"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <div class="col-md-6 mb-3">
            <label>Nội dung gia sư <span class="text-danger">*</span></label>
            <ValidationProvider name="Nội dung" rules="required|max:99" v-slot="{ errors }">
              <el-input v-model="form.content" placeholder="Nhập nội dung gia sư" clearable/>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-md-6 mb-3">
            <label>Link zalo lớp đệm <span class="text-danger">*</span></label>
            <ValidationProvider name="Link Zalo" rules="required|max:99" v-slot="{ errors }">
              <el-input v-model="form.zaloLink" placeholder="Nhập link zalo lớp đệm"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <div class="col-md-6 mb-3">
            <label>Trung tâm <span class="text-danger">*</span></label>
            <ValidationProvider name="center" rules="required" v-slot="{ errors }">
              <el-select v-model="form.centerId" placeholder="Chọn trung tâm" class="w-100" @change="getListBranch">
                <el-option
                    v-for="item in centers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <div class="col-md-6 mb-3">
            <label>Chi nhánh <span class="text-danger">*</span></label>
            <ValidationProvider name="branch" rules="required" v-slot="{ errors }">
              <el-select v-model="form.branchId" placeholder="Chọn chi nhánh" class="w-100" :loading="branchLoading" :disabled="!form.centerId" filterable>
                <el-option
                    v-for="item in branches"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-md-6 mb-3">
            <label>Trình độ học <span class="text-danger">*</span></label>
            <ValidationProvider name="Trình độ" rules="required" v-slot="{ errors }">
              <el-select v-model="form.levelId" placeholder="Chọn trình độ của lớp" class="w-100" clearable filterable>
                <el-option v-for="lv in courses" :key="lv.id" :label="lv.name" :value="lv.id"/>
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-md-6 mb-3">
            <label>Ngày học <span class="text-danger">*</span></label>
            <ValidationProvider name="Ngày học" rules="required" v-slot="{ errors }">
              <el-date-picker v-model="form.date" type="date" class="w-100" placeholder="Chọn ngày" format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd" :picker-options="pickerOptions"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-md-6 mb-3">
            <label>Giờ học <span class="text-danger">*</span></label>
            <ValidationProvider name="Giờ học" rules="required" v-slot="{ errors }">
              <el-select
                  v-model="form.time"
                  placeholder="Chọn giờ học"
                  class="w-100"
                  clearable
                  filterable
                  :disabled="!form.date "
                  :loading="loadingSlot"
                  @focus="getSlot()"
              >
                <el-option-group
                    v-for="group in timeSlots"
                    :key="group.code"
                    :label="group.name">
                  <el-option
                      v-for="item in group.slots"
                      :key="item.start"
                      :label="item.start"
                      :value="item.start"
                      :disabled="item.disable"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <el-button @click="comeBack()">Quay lại</el-button>
          <el-button type="primary" class="ml-2" native-type="submit" :loading="submitting" @click="onSubmit">Đặt lịch
          </el-button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import moment from "moment-timezone";
import {
  CREATE_SPECIAL_TUTOR,
  GET_LIST_LEVEL,
  GET_SLOT,
  POST_BUFFER_CLASS_TUTORING
} from "@/core/services/store/tutor/tutor.module";
import {GET_BRANCH_BY_LIST_CENTER_ID, GET_LIST_BRANCHES} from "@/core/services/store/center/branch.module";

export default {
  name: 'BufferClassTutoring',
  props: {
    timeSlots: {type: Array, default: () => ['07:00 - 08:00', '08:00 - 09:00', '13:00 - 14:00', '19:00 - 20:00']}
  },
  data() {
    return {
      submitting: false,
      form: {classCode: '', content: '', zaloLink: '', levelId: '', date: '', time: '', centerId: '',branchId: ''},
      courses: [
        {id: 1, name: "Basic"},
        {id: 2, name: "PRE IELTS / GTCB"},
        {id: 3, name: "IELTS 3.5-4.5"},
        {id: 4, name: "IELTS 4.5-5.5"},
        {id: 5, name: "IELTS 5.5-6.5"}
      ],
      pickerOptions: {
        disabledDate(time) {
          return moment(time).isBefore(moment().startOf("day"));
        }
      },
      loadingSlot: false,
      centers: [
        {
          name: 'Trung tâm Anh ngữ IELTS Mentor',
          id: 516
        },
        {
          name:'Ecoach',
          id: 295
        }
      ],
      branches: [],
      branchLoading: false
    }
  },
  computed: {
    disablePast() {
      return {disabledDate: d => d.getTime() < Date.now() - 86400000}
    }
  },
  methods: {
    comeBack() {
      this.$emit('closeModal', false)
    },
    async getSlot() {
      this.timeSlots = []
      this.loadingSlot = true
      let payload = {
        subtype: 3,
        day: this.form.date,
        duration: 90
      }
      const data = await this.$store.dispatch(GET_SLOT, payload)
      if (data?.data?.slots.length) {
        const now = Date.now();

        [
          { code: 'morning', name: 'Buổi sáng' },
          { code: 'afternoon', name: 'Buổi chiều' },
          { code: 'evening', name: 'Buổi tối' }
        ].forEach(shift => {
          this.timeSlots.push({
            code: shift.code,
            name: shift.name,
            slots: data.data.slots
                .filter(s => s.code === shift.code)
                .map(slot => ({
                  ...slot,
                  start: this.formatTime(slot.start),
                  disable: new Date(slot.start).getTime() < now // thêm field disable
                }))
          })
        })
      }
      this.loadingSlot = false
    },
    formatTime(isoString, timezone = 'Asia/Ho_Chi_Minh') {
      return moment.tz(isoString, timezone).format('HH:mm:ss');
    },
    async onSubmit() {
      const payload = {
        class_code: this.form.classCode,
        content: this.form.content,
        zalo_link: this.form.zaloLink,
        study_level: this.form.levelId,
        study_date: this.form.date,
        study_time: this.form.time,
        branch_id: this.form.branchId,
        center_id: this.form.centerId,
      }
      try {
        this.submitting = true
        await this.$store.dispatch(POST_BUFFER_CLASS_TUTORING, payload)

        this.$message.success('Đặt lịch gia sư thành công')
        this.closeModal(true)
      } catch (e) {
        this.$message.error(e?.data?.message || 'Có lỗi xảy ra')
      } finally {
        this.submitting = false
      }
    },
    closeModal(isCreateSuccessful = false) {
      this.$emit('closeModal', isCreateSuccessful)
    },
    async getListLevel() {
      const data = await this.$store.dispatch(GET_LIST_LEVEL)
      this.courses = data.data
    },
    async getListBranch() {
      try {
        this.form.branchId = ''
        this.branchLoading = true
        const data = await this.$store.dispatch(GET_LIST_BRANCHES,{center_id: this.form.centerId})
        this.branches = data.data
      }catch (e) {

      }finally {
        this.branchLoading = false
      }

    }
  },
  async mounted() {
    await this.getListLevel()
  }
}
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .12)
}
</style>
